// frontend/src/store/slices/quoteSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../services/api';

export const fetchQuotes = createAsyncThunk(
    'quotes/fetch',
    async (status = '', { rejectWithValue }) => {
        try {
            const url = status ? `/quotes?status=${status}` : '/quotes';
            const { data } = await api.get(url);
            return data;
        } catch (err) {
            return rejectWithValue(err.response?.data?.error || 'Failed to fetch quotes');
        }
    }
);

export const createQuote = createAsyncThunk(
    'quotes/create',
    async (quoteData, { rejectWithValue }) => {
        try {
            const isFormData =
                typeof FormData !== 'undefined' && quoteData instanceof FormData;

            const { data } = await api.post('/quotes', quoteData, {
                headers: isFormData
                    ? { 'Content-Type': 'multipart/form-data' }
                    : { 'Content-Type': 'application/json' },
            });
            return data;
        } catch (err) {
            return rejectWithValue(
                err.response?.data?.error ||
                err.response?.data?.message ||
                'Failed to create quote'
            );
        }
    }
);

const quoteSlice = createSlice({
    name: 'quotes',
    initialState: {
        items: [],
        selectedQuote: null,
        loading: false,
        error: null,
    },
    reducers: {
        clearQuotes: (state) => {
            state.items = [];
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchQuotes.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchQuotes.fulfilled, (state, action) => {
                state.loading = false;
                state.items = Array.isArray(action.payload) ? action.payload : [];
            })
            .addCase(fetchQuotes.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.items = [];
            })
            .addCase(createQuote.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createQuote.fulfilled, (state, action) => {
                state.loading = false;
                state.items.unshift(action.payload);
            })
            .addCase(createQuote.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const { clearQuotes } = quoteSlice.actions;
export default quoteSlice.reducer;